import { createContext } from 'react';

import type { LeadCardContextValue } from '@app/components/LeadCard/context/hooks/useProviderValue';

type Nullable<T> = T | null;

export const LeadCardContext =
  createContext<Nullable<LeadCardContextValue>>(null);
